import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ClientPortal from "@/pages/ClientPortal";
import BusinessHub from "@/pages/BusinessHub";
import PaymentSuccess from "@/pages/PaymentSuccess";

import PlatformConsole from "@/pages/PlatformConsole";
import OrgDashboard from "@/pages/OrgDashboard";
import Flows from "@/pages/Flows";
import FlowBuilder from "@/pages/FlowBuilder";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Team from "@/pages/Team";
import Billing from "@/pages/Billing";
import OrgSettings from "@/pages/OrgSettings";

const ORG_ROLES = ["org_admin", "org_member"];

function Protected({ children, allow }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground overline">Loading OnboardHQ…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (allow && !allow.includes(user.role)) {
    return <Navigate to={user.role === "platform_admin" ? "/platform" : "/app"} replace />;
  }
  return <AppLayout>{children}</AppLayout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/onboard/:token" element={<ClientPortal />} />
            <Route path="/hub/:slug" element={<BusinessHub />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />

            {/* Platform super-admin */}
            <Route path="/platform" element={<Protected allow={["platform_admin"]}><PlatformConsole /></Protected>} />

            {/* Org workspace */}
            <Route path="/app" element={<Protected allow={ORG_ROLES}><OrgDashboard /></Protected>} />
            <Route path="/app/flows" element={<Protected allow={ORG_ROLES}><Flows /></Protected>} />
            <Route path="/app/flows/new" element={<Protected allow={ORG_ROLES}><FlowBuilder /></Protected>} />
            <Route path="/app/flows/:id/edit" element={<Protected allow={ORG_ROLES}><FlowBuilder /></Protected>} />
            <Route path="/app/clients" element={<Protected allow={ORG_ROLES}><Clients /></Protected>} />
            <Route path="/app/clients/:id" element={<Protected allow={ORG_ROLES}><ClientDetail /></Protected>} />
            <Route path="/app/team" element={<Protected allow={["org_admin"]}><Team /></Protected>} />
            <Route path="/app/billing" element={<Protected allow={["org_admin"]}><Billing /></Protected>} />
            <Route path="/app/settings" element={<Protected allow={["org_admin"]}><OrgSettings /></Protected>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
